import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import HomePage from "@/pages/HomePage";
import ProductPage from "@/pages/ProductPage";
import GeraeteOverviewPage from "@/pages/GeraeteOverviewPage";
import DevicePage from "@/pages/DevicePage";
import ContactPage from "@/pages/ContactPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/anhaenger" element={<ProductPage />} />
            <Route path="/geraete" element={<GeraeteOverviewPage />} />
            <Route path="/geraete/:slug" element={<DevicePage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
